"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeSegmentMaskKeys = exports.defaultTimeAriaLabels = void 0;
var timeSegmentMaskKeys = {
  hours: 'hh',
  minutes: 'mm',
  seconds: 'ss',
  milliseconds: 'sss'
};
exports.timeSegmentMaskKeys = timeSegmentMaskKeys;
var defaultTimeAriaLabels = {
  hours: 'Hours',
  minutes: 'Minutes',
  seconds: 'Seconds',
  milliseconds: 'Milliseconds',
  increase: {
    hours: 'Increase hours',
    minutes: 'Increase minutes',
    seconds: 'Increase seconds',
    milliseconds: 'Increase milliseconds'
  },
  decrease: {
    hours: 'Decrease hours',
    minutes: 'Decrease minutes',
    seconds: 'Decrease seconds',
    milliseconds: 'Decrease milliseconds'
  }
};
exports.defaultTimeAriaLabels = defaultTimeAriaLabels;